import { createSlice } from "../helper";
import { findObjectIndexByKeyValue } from "../../utils/CoreExtensions/ArrayExtensions";
import { assignNewKeysOnly } from "../../utils/GeneralUtils";

const initialState = {
  previewDetails: {}
};

const guidedConversationSlice = createSlice({
  name: "guidedConversation",
  initialState,
  reducers: {
    replacePreviewDetails(state, action) {
      state.previewDetails = action.payload.data;
    },
    setAgendaSectionsForGuide(state, action) {
      const { uId, data } = action.payload;
      const indexToUpdate = findObjectIndexByKeyValue(state.previewDetails.guides, "id", uId);
      assignNewKeysOnly(state.previewDetails.guides[indexToUpdate], data);
    },
    updateGuideDetails(state, action) {
      const { uId, data } = action.payload;
      const indexToUpdate = findObjectIndexByKeyValue(state.previewDetails.guides, "id", uId);
      state.previewDetails.guides[indexToUpdate] = { ...state.previewDetails.guides[indexToUpdate], ...data };
    },
    updateNextFocusedGuide(state, action) {
      const { uId, data } = action.payload;
      state.previewDetails.focusedGuideId = uId;
    },
    setIsUpdated(state, action) {
      const { uId, data } = action.payload;
      state.previewDetails.isUpdated = data;
    }
  }
});

export const guidedConversationActions = guidedConversationSlice.actions;
export default guidedConversationSlice;
